export default __webpack_public_path__ + "static/media/kpi-users.7c562b14.svg";